export default "__VITE_ASSET__76cca697__"